import React from "react";
import { Routes, Route } from "react-router-dom";

// Import PM-SHRI screens
import PMShriDashboard from "../screens/PMShriDashboard";
import HeadAnalyticsScreen from "../screens/HeadAnalyticsScreen";
import SubheadAnalyticsScreen from "../screens/SubheadAnalyticsScreen";
import ActivityAnalyticsScreen from "../screens/ActivityAnalyticsScreen";
import SubActivityAnalyticsScreen from "../screens/SubActivityAnalyticsScreen";
import SchoolDetailsScreen from "../screens/SchoolDetailsScreen";
import RegionAnalyticsScreen from "../screens/RegionAnalyticsScreen";
import ActivityTreeScreen from "../screens/ActivityTreeScreen";

import ExpenseActivityTreeScreen from "../screens/ExpenseActivityTreeScreen";
import ExpenditureActivityTreeScreen from "../screens/ExpenditureActivityTreeScreen";

const PmShriRoutes: React.FC = () => (
  <Routes>
    {/* Main Dashboard */}
    <Route path="/" element={<PMShriDashboard />} />

    {/* Activity Tree - Navigate through activity hierarchy */}
    <Route path="/activity-tree" element={<ActivityTreeScreen />} />
    <Route path="/expense-activity-tree" element={<ExpenseActivityTreeScreen />} />
    <Route path="/expenditure-activity-tree" element={<ExpenditureActivityTreeScreen />} />

    {/* Head Analytics Flow */}
    <Route path="/analytics/heads/:headCode" element={<HeadAnalyticsScreen />} />
    <Route path="/analytics/heads/:headCode/subheads/:subheadId" element={<SubheadAnalyticsScreen />} />
    <Route path="/analytics/heads/:headCode/subheads/:subheadId/activities/:activityId" element={<ActivityAnalyticsScreen />} />
    <Route path="/analytics/heads/:headCode/subheads/:subheadId/activities/:activityId/subactivities/:subActivityId" element={<SubActivityAnalyticsScreen />} />

    {/* Region Analytics */}
    <Route path="/analytics/regions/:roId" element={<RegionAnalyticsScreen />} />

    {/* School Details */}
    <Route path="/schools/:kvId" element={<SchoolDetailsScreen />} />
  </Routes>
);

export default PmShriRoutes;
